import React from 'react'
import styled from 'react-emotion'

const Container = styled.div`
  margin-bottom 3rem;
`

const Hero = styled.div(props => `
  background-image: url(${props.src});
  background-position: center center;
  height: 270px;
  background-repeat: no-repeat;
  background-size: cover;
`)

const HeroImage = (props) => {
  return (
    <Container>
      <Hero src={props.src} alt={props.alt} />
    </Container>
  );
}
 
export default HeroImage;


// WEBPACK FOOTER //
// ./src/components/HeroImage.js